import type { NPCConfig } from '@/entities';
import type { DialogTree } from '@/types/DialogTypes';
import V2Day1Part0NPC from "@/config/NPCConfigs/v2/V2Day1Part0NPC.ts";
import V2Day1EpilogueDialog from "@/config/NPCConfigs/v2/V2Day1EpilogueDialog.ts";
import V2Day1Part1Dialog from "@/config/NPCConfigs/v2/V2Day1Part1Dialog.ts";
import V2Day1Part1NPCs from "@/config/NPCConfigs/v2/V2Day1Part1NPCs.ts";
import V2Day1Part2NPCs from "@/config/NPCConfigs/v2/V2Day1Part2NPCs.ts";
import V2Day1Part3NPCs from "@/config/NPCConfigs/v2/V2Day1Part3NPCs";
import V2Day1Part4NPCs from "@/config/NPCConfigs/v2/V2Day1Part4NPCs";
import V2Day1Part5StartingDialog from "@/config/NPCConfigs/v2/V2Day1Part5StartingDialog.ts";
import V2Day1Part4StartingDialog from "@/config/NPCConfigs/v2/V2Day1Part4StartingDialog.ts";
import V2Day1Part5NPCs from "@/config/NPCConfigs/v2/V2Day1Part5NPCs.ts";
import V2Day2Part1StartingDialog from "@/config/NPCConfigs/v2/V2Day2Part1StartingDialog";
import V2Day2Part1NPCs from "@/config/NPCConfigs/v2/V2Day2Part1ANPCs.ts";
import V2Day2PartA2NPCs from "@/config/NPCConfigs/v2/V2Day2Part1BNPCs.ts";
import V2Day2Part2NPCs from "@/config/NPCConfigs/v2/V2Day2Part2NPCs";
import V2Day2Part2StartingDialog from "@/config/NPCConfigs/v2/V2Day2Part2StartingDialog";
import V2Day2Part3StartingDialog from "@/config/NPCConfigs/v2/V2Day2Part3StartingDialog";
import V2Day2Part3NPCs from "@/config/NPCConfigs/v2/V2Day2Part3NPCs";
import V2Day3Part1StartingDialog from "@/config/NPCConfigs/v2/V2Day3Part1StartingDialog";
import V2Day3Part1aNPCs from "@/config/NPCConfigs/v2/V2Day3Part1aNPCs";
import V2Day3Part1bNPCs from "@/config/NPCConfigs/v2/V2Day3Part1bNPCs";
import V2Day3Part1cNPCs from "@/config/NPCConfigs/v2/V2Day3Part1cNPCs";
import V2Day3Part1dNPCs from "@/config/NPCConfigs/v2/V2Day3Part1dNPCs";
import V2Day3Part1eNPCs from "@/config/NPCConfigs/v2/V2Day3Part1eNPCs";
import V2Day3PartBadEndingExitTownNPCs from "@/config/NPCConfigs/v2/V2Day3PartBadEndingExitTownNPCs";
import V2Day3Part2NPCs from "@/config/NPCConfigs/v2/V2Day3Part2NPCs";

export interface DayConfig {
  day: number;
  dayString?:string;
  name: string;
  description?: string;
  npcs: NPCConfig[];
  initialDialog?: DialogTree; // Optional initial dialog that plays when the day starts
  position?: { x: number; y: number };
  facing?: string; // Optional facing direction (N, NE, E, SE, S, SW, W, NW)
  music?: string; // Sound ID for background music for this day
}

const DAY_CONFIGS: DayConfig[] = [
  {
    day: 1,
    dayString : "Prolog",
    name: 'Pulang',
    description:
      '',
    npcs: V2Day1Part0NPC,
    music: 'piano',
    initialDialog: {
      ...V2Day1EpilogueDialog,
    },
  },
  {
    day: 2,
    dayString : "Hari 1",
    name: 'Petualangan',
    description:
      '• Cari kado untuk Diana\n• Cari Diana',
    npcs: V2Day1Part1NPCs,
    music: 'piano',
    initialDialog: {
      ...V2Day1Part1Dialog,
    },
  },
  {
    day: 3,
    dayString : "Hari 1",
    name: 'Petualangan',
    description:
        '• Cari kado untuk Diana',
    npcs: V2Day1Part2NPCs,
    music: 'piano',
    initialDialog: {
      startDialogId: 'part3_opening0',
      nodes: {
        part3_opening0: {
          id: 'part3_opening0',
          speaker: 'Yan',
          text: `Sebaiknya selagi disini kita mengunjungi makam ibu.`,
          isEnd : true
        },
      },
    },
  },
  {
    day: 4,
    dayString : "Hari 1",
    name: 'Petualangan',
    description:
        '• Cari kado untuk Diana\n• Bertemu dengan yang lain di Danau',
    npcs: V2Day1Part3NPCs,
    music: 'piano',
    initialDialog: {
      startDialogId: 'part3_opening0',
      nodes: {
        part3_opening0: {
          id: 'part3_opening0',
          speaker: 'Yan',
          text: `Sebaiknya kita ke danau setelah menemukan sesuatu untuk diberikan untuk Diana.`,
          isEnd : true
        },
      },
    },
  },
  {
    day: 5,
    dayString : "Hari 1",
    name: 'Pencarian',
    description:
        '• Cari tahu tentang kematian Sondakh\n• Pergi ke Gereja dengan Romo dan lainnya',
    npcs: V2Day1Part4NPCs,
    music: 'piano',
    initialDialog: V2Day1Part4StartingDialog
  },
  {
    day: 6,
    dayString : "Hari 1",
    name: 'Petualangan',
    description:
        '• Bersihkan nama Diana dan Elsa\n• Kembali ke Diana',
    npcs: V2Day1Part5NPCs,
    position : {
      x : 2370, y: 800
    },
    facing : 'NW',
    music: 'piano',
    initialDialog: V2Day1Part5StartingDialog
  },
  {
    day: 7,
    dayString : "Hari 2",
    name: '',
    description: '',
    npcs: V2Day2Part1NPCs,
    position : {
      x: 1880, y: 1545,
    },
    facing : 'S',
    music: 'piano',
    initialDialog: V2Day2Part1StartingDialog
  },
  {
    day: 8,
    dayString : "Hari 2",
    name: '',
    description: '',
    npcs: V2Day2PartA2NPCs,
    music: 'piano',
    initialDialog: {
      startDialogId: 'op1',
      nodes: {
        op1: {
          id: 'op1',
          speaker: 'Romo Darius',
          text: `Tuhan Memberkati. Saya pergi dulu ya`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/desa.png',
          isEnd : true
          //TODO kalau bisa diilingain karena kejadian ini bisa jadi dinamis
        },
      },
    }
  },
  {
    day: 9,
    dayString : "Hari 2",
    name: '',
    description:
        '• Cari tahu tentang kematian Diana\n• Ke Gereja untuk Misa',
    npcs: V2Day2Part2NPCs,
    position : {
      x: 1880, y: 1545,
    },
    facing : 'S',
    music: 'piano',
    initialDialog: V2Day2Part2StartingDialog
  },
  {
    day: 10,
    dayString : "Hari 2",
    name: '',
    description:
        '• Pulang dan beristirahat',
    npcs: V2Day2Part3NPCs,
    music: 'piano',
    initialDialog: V2Day2Part3StartingDialog
  },
  {
    day: 11,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    npcs: V2Day3Part1aNPCs,
    music: 'piano',
    initialDialog: V2Day3Part1StartingDialog
  },
  {
    day: 12,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    npcs: V2Day3Part1bNPCs,
    music: 'piano',
  },
  {
    day: 13,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    npcs: V2Day3Part1cNPCs,
    music: 'piano',
  },
  {
    day: 14,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    npcs: V2Day3Part1dNPCs,
    music: 'piano',
  },
  {
    day: 15,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    npcs: V2Day3PartBadEndingExitTownNPCs,
    music: 'piano',
  },
  {
    day: 16,
    dayString : "Hari 3",
    name: '',
    description: '• Buktikan Elsa tidak bersalah',
    npcs: V2Day3Part2NPCs,
    music: 'piano',
    position : {
      x: 1800,
      y: 1320,
    },
    facing : "W"
  },
];

export const dayConfigs: DayConfig[] = DAY_CONFIGS